const isProjectFromGlobalTemplatesChannel = (channel?: number) => {
  if (!channel) return false;

  const globalChannel = import.meta.env.VITE_GLOBAL_TEMPLATES_CHANNEL
    ? parseInt(import.meta.env.VITE_GLOBAL_TEMPLATES_CHANNEL)
    : 0;

  return channel === globalChannel;
};

export default isProjectFromGlobalTemplatesChannel;
